import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

import { UploadFile } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

const defaultGetFileValue = ({ id }) => id;

const FormAttachmentField = withFormField()(({
  area,
  label,
  value = [],
  error,
  helper,
  type,
  accept = '.pdf, image/png,  image/jpg, image/jpeg, .doc, .docx, .xls, .xlsx',
  tooltip = '.pdf, .png, .jpg, .jpeg, .doc, .docx, .xls, .xlsx',
  multiple,
  onUpload,
  onChange,
  getFileLabel,
  getFileKey,
  getFileValue = defaultGetFileValue,
  disabled,
  variant,
  direction,
  fileLabels,
  ...props
}) => {
  const handleUpload = (e, filesFormData = []) => {
    if (multiple) {
      return Promise.all(filesFormData.map((file) => onUpload(file))).then(
        (uploadedFiles) => {
          onChange(e, [...(value || []), ...uploadedFiles], type);
          return uploadedFiles;
        }
      );
    }

    return onUpload(filesFormData[0])?.then((uploadedFile) => {
      onChange(e, uploadedFile, type);
      return uploadedFile;
    });
  };

  const handleRemove = (e, file) => {
    onChange(
      e,
      multiple
        ? value.filter((item) => getFileValue(item) !== getFileValue(file))
        : null
    );
  };

  return (
    <UploadFile
      label={label}
      value={value}
      error={error}
      helper={helper}
      accept={accept}
      onUpload={handleUpload}
      onRemove={handleRemove}
      getFileLabel={getFileLabel}
      getFileKey={getFileKey}
      multiple={multiple}
      tooltip={tooltip}
      disabled={disabled}
      variant={variant}
      direction={direction}
      fileLabels={fileLabels}
      {...omitFormProps(props)}
    />
  );
});

export default hoistNonReactStatics(FormAttachmentField, UploadFile);
